import React from 'react';
import { Select } from 'antd';

type FilterField = 'isActive' | 'clientIsActive';

const statusFilters = ['All', 'Active', 'InActive'];

export const filterByStatus = (filterField: FilterField) => (filter: any, row: any) => {
    if (filter.value === 'All') {
        return true;
    }
    if (filter.value === 'Active' && row[filterField] === true) {
        return true;
    }
    if (filter.value === 'InActive' && row[filterField] === false) {
        return true;
    }
    return false;
};

export const setStatusCellValue = (row: any) => {
    return row.value === true ? 'Active' : 'InActive';
};

export const StatusFilterMethod = ({ filter, onChange }: { filter: any, onChange: any }) => (
    <Select
        className="py-0"
        onChange={onChange}
        value={filter ? filter.value : 'Active'}
    >
        {statusFilters.map((item) =>
            <Select.Option key={item} value={item}>{item}</Select.Option>)}
    </Select>
);